import { render, staticRenderFns } from "./assignFileTypeEditor.vue?vue&type=template&id=190818f2&"
import script from "./assignFileTypeEditor.vue?vue&type=script&lang=js&"
export * from "./assignFileTypeEditor.vue?vue&type=script&lang=js&"
import style0 from "./assignFileTypeEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('190818f2')) {
      api.createRecord('190818f2', component.options)
    } else {
      api.reload('190818f2', component.options)
    }
    module.hot.accept("./assignFileTypeEditor.vue?vue&type=template&id=190818f2&", function () {
      api.rerender('190818f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/assignFileTypeEditor.vue"
export default component.exports